import { render, staticRenderFns } from "./ForgotPasswordView.vue?vue&type=template&id=a8e79b06"
import script from "./ForgotPasswordView.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordView.vue?vue&type=style&index=0&id=a8e79b06&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiInput: require('/home/node/app/components/ui/uiInput.vue').default,Btn: require('/home/node/app/components/ui/btn.vue').default,ControllerForgotPassword: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/user/ControllerForgotPassword.js').default,OpenedEye: require('/home/node/app/assets/icons/opened-eye.vue').default,ClosedEye: require('/home/node/app/assets/icons/closed-eye.vue').default,ControllerResetPassword: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/user/ControllerResetPassword.js').default})
